export default __webpack_public_path__ + "static/media/bag.dcac860f.jpg";